// src/utils/pdfUtils.js

/**
 * Font dosyas�n� public klas�r�nden fetch ederek Base64 string'e �evirir.
 * @param {string} url   - public folder i�indeki font dosyas�n�n yolu (�rn: '/fonts/Roboto-Regular.ttf')
 * @returns {Promise<string>}  - "iVBORw0KGgoAAAANSU..." gibi Base64 string
 */
export async function loadFontAsBase64(url) {
    // 1) fetch ile fontu �ek
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Font dosyas� indirilemedi: ${response.status} ${response.statusText}`);
    }

    // 2) arrayBuffer'� al
    const arrayBuffer = await response.arrayBuffer();

    // 3) Uint8Array'e �evir
    const uint8Array = new Uint8Array(arrayBuffer);

    // 4) Her byte'� String.fromCharCode ile birle�tirip "binary string" elde et
    let binaryString = '';
    for (let i = 0; i < uint8Array.length; i++) {
        binaryString += String.fromCharCode(uint8Array[i]);
    }

    // 5) btoa ile Base64'e d�n��t�r
    const base64String = btoa(binaryString);

    return base64String;
}

export async function loadImageAsBase64(url) {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`G�rsel y�klenemedi: ${response.status} ${response.statusText}`);
    }
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            // reader.result e.g. "data:image/png;base64,iVBORw0KGgoAAAANS�"
            const base64data = reader.result.split(',')[1];
            resolve(base64data);
        };
        reader.onerror = err => {
            reject(err);
        };
        reader.readAsDataURL(blob);
    });
}